import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/bp/definitions', label: 'Definitions',  testid: 'bp-nav-definitions' },
  { to: '/bp/delegations', label: 'Delegations',  testid: 'bp-nav-delegations' },
  { to: '/bp/runs',        label: 'Runs',          testid: 'bp-nav-runs' },
];

export default function BpShell() {
  return (
    <div className="hr-shell" data-testid="bp-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Business Processes</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
